import { SchoolsList } from './SchoolsList';

export default SchoolsList;